import { makeStyles } from '@material-ui/styles';
import { COLORS } from '../../../styles/color.styles';

export const customSpinnerStyles = makeStyles({
	containerLoader: {
		width: '100%',
		backdropFilter: 'blur(1px)',
		backgroundColor: 'rgba(245, 245, 245, 0.8)',
		height: '100vh',
		position: 'fixed',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		zIndex: 5,
		top: 0,
		left: 0,
	},
	loader: {
		fontSize: '10px',
		margin: '0 auto',
		textIndent: '-9999em',
		width: '11em',
		height: '11em',
		borderRadius: '50%',
		background: `radial-gradient(circle at 93% 5.1em, ${COLORS.secondary} 7px, rgba(0, 0, 0, 0) 0.2em),conic-gradient(from 90deg at 50% 50%, rgba(243, 181, 36, 0) 0deg, ${COLORS.secondary} 359.96deg, rgba(243, 181, 36, 0) 360deg)`,
		position: 'relative',
		animation: '$myEffect 1.4s infinite linear',
		transform: 'translateZ(0)',
		'&:before': {
			width: '50%',
			height: '50%',
			background: '#ffffff',
			borderRadius: '100% 0 0 0',
			position: 'absolute',
			top: 0,
			left: 0,
		},
		'&:after': {
			backgroundColor: 'rgba(245, 245, 245, 1)',
			width: '75%',
			height: '75%',
			borderRadius: '50%',
			content: '""',
			margin: 'auto',
			position: 'absolute',
			top: '0',
			left: '0',
			bottom: '0',
			right: '0',
		},
	},
	loaderTop: {
		margin: 'auto',
		marginTop: 30,
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
	},
	'@keyframes myEffect': {
		'0%': {
			backgroundColor: `rgba(255, 255, 255, 0.3)`,
			transform: 'rotate(0deg)',
		},
		'35%': {
			backgroundColor: `rgba(${COLORS.primaryRGB}, 0.2)`,
			transform: 'rotate(126deg)',
		},
		'50%': {
			backgroundColor: `rgba(${COLORS.primaryRGB}, 0.4)`,
			transform: 'rotate(180deg)',
		},
		'65%': {
			backgroundColor: `rgba(${COLORS.primaryRGB}, 0.2)`,
			transform: 'rotate(234deg)',
		},
		'80%': {
			backgroundColor: `rgba(${COLORS.primaryRGB}, 0.1)`,
			transform: 'rotate(288deg)',
		},
		'100%': {
			backgroundColor: `rgba(${COLORS.secondaryRGB}, 0.3)`,
			transform: 'rotate(360deg)',
		},
	},
});
